// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"52cfc8dd","377":"9e47f0af","417":"487d20fc","467":"bc20accb","626":"e5e40771","870":"c82e7496"}[chunkId] + ".js";
};